import { mdiHomeOutline, mdiMenu, mdiCash } from '@mdi/js'

export default [
  {
    title: 'Accueil',
    icon: mdiHomeOutline,
    to: 'dashboard-analytics',
  }
]
